var map = {
	"./svg/HTML5.svg": 805,
	"./svg/actix.svg": 806,
	"./svg/aiohttp.svg": 807,
	"./svg/amd.svg": 808,
	"./svg/amixr.svg": 809,
	"./svg/android.svg": 810,
	"./svg/angularjs.svg": 811,
	"./svg/app-engine.svg": 812,
	"./svg/apple.svg": 813,
	"./svg/asana.svg": 814,
	"./svg/asayer.svg": 815,
	"./svg/auth0.svg": 816,
	"./svg/aws.svg": 817,
	"./svg/awslamda.svg": 818,
	"./svg/azure.svg": 819,
	"./svg/backbone.svg": 820,
	"./svg/bitbucket.svg": 821,
	"./svg/bootstrap.svg": 822,
	"./svg/bottle.svg": 823,
	"./svg/campfire.svg": 824,
	"./svg/celery.svg": 825,
	"./svg/chalice.svg": 826,
	"./svg/chrome.svg": 827,
	"./svg/clickup.svg": 828,
	"./svg/clojure.svg": 829,
	"./svg/clubhouse.svg": 830,
	"./svg/connect.svg": 831,
	"./svg/cordova.svg": 832,
	"./svg/csharp.svg": 833,
	"./svg/dart.svg": 834,
	"./svg/datadog.svg": 835,
	"./svg/default.svg": 836,
	"./svg/django.svg": 837,
	"./svg/dotnet.svg": 838,
	"./svg/dotnetcore.svg": 839,
	"./svg/electron.svg": 840,
	"./svg/elixir.svg": 841,
	"./svg/ember.svg": 842,
	"./svg/express.svg": 843,
	"./svg/falcon.svg": 844,
	"./svg/firetv.svg": 845,
	"./svg/flask.svg": 846,
	"./svg/flowdock.svg": 847,
	"./svg/flutter.svg": 848,
	"./svg/fsharp.svg": 849,
	"./svg/fullstory.svg": 850,
	"./svg/gcp.svg": 851,
	"./svg/generic.svg": 852,
	"./svg/github.svg": 853,
	"./svg/gitlab.svg": 854,
	"./svg/go.svg": 855,
	"./svg/google.svg": 856,
	"./svg/heroku.svg": 857,
	"./svg/intellinote.svg": 858,
	"./svg/ios.svg": 859,
	"./svg/java.svg": 860,
	"./svg/javascript.svg": 861,
	"./svg/jira.svg": 862,
	"./svg/koa.svg": 863,
	"./svg/kotlin.svg": 864,
	"./svg/laravel.svg": 865,
	"./svg/lighthouse.svg": 866,
	"./svg/linear.svg": 867,
	"./svg/logback.svg": 868,
	"./svg/msteams.svg": 869,
	"./svg/nativec.svg": 870,
	"./svg/net5.svg": 871,
	"./svg/nodejs.svg": 872,
	"./svg/okta.svg": 873,
	"./svg/onelogin.svg": 874,
	"./svg/opsgenie.svg": 875,
	"./svg/pagerduty.svg": 876,
	"./svg/perl.svg": 877,
	"./svg/phabricator.svg": 878,
	"./svg/php.svg": 879,
	"./svg/pivotaltracker.svg": 880,
	"./svg/pushover.svg": 881,
	"./svg/pyramid.svg": 882,
	"./svg/python.svg": 883,
	"./svg/rails.svg": 884,
	"./svg/react.svg": 885,
	"./svg/redis.svg": 886,
	"./svg/redmine.svg": 887,
	"./svg/redux.svg": 888,
	"./svg/relay.svg": 889,
	"./svg/rippling.svg": 890,
	"./svg/rocketchat.svg": 891,
	"./svg/rookout.svg": 892,
	"./svg/ruby.svg": 893,
	"./svg/rust.svg": 894,
	"./svg/saml2.svg": 895,
	"./svg/segment.svg": 896,
	"./svg/sentry.svg": 897,
	"./svg/serverless.svg": 898,
	"./svg/slack.svg": 899,
	"./svg/split.svg": 900,
	"./svg/spring.svg": 901,
	"./svg/springboot.svg": 902,
	"./svg/sprintly.svg": 903,
	"./svg/swift.svg": 904,
	"./svg/symfony.svg": 905,
	"./svg/taiga.svg": 906,
	"./svg/teamwork.svg": 907,
	"./svg/tornado.svg": 908,
	"./svg/trello.svg": 909,
	"./svg/tryton.svg": 910,
	"./svg/twilio.svg": 911,
	"./svg/unity.svg": 912,
	"./svg/unreal.svg": 913,
	"./svg/vercel.svg": 914,
	"./svg/visualbasic.svg": 915,
	"./svg/vue.svg": 916,
	"./svg/windows.svg": 917,
	"./svg/youtrack.svg": 918,
	"./svg/zendesk.svg": 919,
	"./svg/zulip.svg": 920,
	"./svg_80x80/HTML5.svg": 1538,
	"./svg_80x80/actix.svg": 1539,
	"./svg_80x80/aiohttp.svg": 1540,
	"./svg_80x80/amd.svg": 1541,
	"./svg_80x80/amixr.svg": 1542,
	"./svg_80x80/android.svg": 1543,
	"./svg_80x80/angularjs.svg": 1544,
	"./svg_80x80/app-engine.svg": 1545,
	"./svg_80x80/apple.svg": 1546,
	"./svg_80x80/asana.svg": 1547,
	"./svg_80x80/asayer.svg": 1548,
	"./svg_80x80/auth0.svg": 1549,
	"./svg_80x80/aws.svg": 1550,
	"./svg_80x80/awslamda.svg": 1551,
	"./svg_80x80/azure.svg": 1552,
	"./svg_80x80/backbone.svg": 1553,
	"./svg_80x80/bitbucket.svg": 1554,
	"./svg_80x80/bootstrap.svg": 1555,
	"./svg_80x80/bottle.svg": 1556,
	"./svg_80x80/campfire.svg": 1557,
	"./svg_80x80/celery.svg": 1558,
	"./svg_80x80/chalice.svg": 1559,
	"./svg_80x80/chrome.svg": 1560,
	"./svg_80x80/clickup.svg": 1561,
	"./svg_80x80/clojure.svg": 1562,
	"./svg_80x80/clubhouse.svg": 1563,
	"./svg_80x80/connect.svg": 1564,
	"./svg_80x80/cordova.svg": 1565,
	"./svg_80x80/csharp.svg": 1566,
	"./svg_80x80/dart.svg": 1567,
	"./svg_80x80/datadog.svg": 1568,
	"./svg_80x80/default.svg": 1569,
	"./svg_80x80/django.svg": 1570,
	"./svg_80x80/dotnet.svg": 1571,
	"./svg_80x80/electron.svg": 1572,
	"./svg_80x80/elixir.svg": 1573,
	"./svg_80x80/ember.svg": 1574,
	"./svg_80x80/express.svg": 1575,
	"./svg_80x80/falcon.svg": 1576,
	"./svg_80x80/firetv.svg": 1577,
	"./svg_80x80/flask.svg": 1578,
	"./svg_80x80/flowdock.svg": 1579,
	"./svg_80x80/flutter.svg": 1580,
	"./svg_80x80/fsharp.svg": 1581,
	"./svg_80x80/fullstory.svg": 1582,
	"./svg_80x80/gcp.svg": 1583,
	"./svg_80x80/github-enterprise.svg": 1584,
	"./svg_80x80/github.svg": 1585,
	"./svg_80x80/gitlab.svg": 1586,
	"./svg_80x80/go.svg": 1587,
	"./svg_80x80/google.svg": 1588,
	"./svg_80x80/heroku.svg": 1589,
	"./svg_80x80/intellinote.svg": 1590,
	"./svg_80x80/ios.svg": 1591,
	"./svg_80x80/java.svg": 1592,
	"./svg_80x80/javascript.svg": 1593,
	"./svg_80x80/jira-server.svg": 1594,
	"./svg_80x80/jira.svg": 1595,
	"./svg_80x80/koa.svg": 1596,
	"./svg_80x80/kotlin.svg": 1597,
	"./svg_80x80/laravel.svg": 1598,
	"./svg_80x80/lighthouse.svg": 1599,
	"./svg_80x80/linear.svg": 1600,
	"./svg_80x80/logback.svg": 1601,
	"./svg_80x80/mnet.svg": 1602,
	"./svg_80x80/msteams.svg": 1603,
	"./svg_80x80/nativec.svg": 1604,
	"./svg_80x80/net5.svg": 1605,
	"./svg_80x80/nodeglyph.svg": 1606,
	"./svg_80x80/nodejs.svg": 1607,
	"./svg_80x80/objc-cocoa.svg": 1608,
	"./svg_80x80/okta.svg": 1609,
	"./svg_80x80/onelogin.svg": 1610,
	"./svg_80x80/opsgenie.svg": 1611,
	"./svg_80x80/pagerduty.svg": 1612,
	"./svg_80x80/perl.svg": 1613,
	"./svg_80x80/phabricator.svg": 1614,
	"./svg_80x80/php.svg": 1615,
	"./svg_80x80/pivotaltracker.svg": 1616,
	"./svg_80x80/pushover.svg": 1617,
	"./svg_80x80/pyramid.svg": 1618,
	"./svg_80x80/python.svg": 1619,
	"./svg_80x80/rails.svg": 1620,
	"./svg_80x80/react.svg": 1621,
	"./svg_80x80/redis.svg": 1622,
	"./svg_80x80/redmine.svg": 1623,
	"./svg_80x80/redux.svg": 1624,
	"./svg_80x80/relay.svg": 1625,
	"./svg_80x80/rippling.svg": 1626,
	"./svg_80x80/rocketchat.svg": 1627,
	"./svg_80x80/rookout.svg": 1628,
	"./svg_80x80/ruby.svg": 1629,
	"./svg_80x80/rust.svg": 1630,
	"./svg_80x80/saml2.svg": 1631,
	"./svg_80x80/segment.svg": 1632,
	"./svg_80x80/sentry.svg": 1633,
	"./svg_80x80/serverless.svg": 1634,
	"./svg_80x80/slack.svg": 1635,
	"./svg_80x80/split.svg": 1636,
	"./svg_80x80/spring.svg": 1637,
	"./svg_80x80/spring_logo-spring.svg": 1638,
	"./svg_80x80/springboot.svg": 1639,
	"./svg_80x80/sprintly.svg": 1640,
	"./svg_80x80/swift.svg": 1641,
	"./svg_80x80/symfony.svg": 1642,
	"./svg_80x80/taiga.svg": 1643,
	"./svg_80x80/teamwork.svg": 1644,
	"./svg_80x80/tornado.svg": 1645,
	"./svg_80x80/trello.svg": 1646,
	"./svg_80x80/tryton.svg": 1647,
	"./svg_80x80/twilio.svg": 1648,
	"./svg_80x80/unity.svg": 1649,
	"./svg_80x80/unreal.svg": 1650,
	"./svg_80x80/vercel.svg": 1651,
	"./svg_80x80/visualbasic.svg": 1652,
	"./svg_80x80/vue.svg": 1653,
	"./svg_80x80/windows.svg": 1654,
	"./svg_80x80/youtrack.svg": 1655,
	"./svg_80x80/zendesk.svg": 1656,
	"./svg_80x80/zulip.svg": 1657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1537;